import { applicationError, updateLocale } from '@americanexpress/one-app-ducks';
import { supportedLocales } from './provideStateConfig';
import { MODULE_NAME } from './constants';

export default function updateLocaleFromRoute({ dispatch }) {
  return async (nextState, replace, callback) => {
    const { location, params: { locale } } = nextState;

    try {
      if (!locale) {
        throw new Error('Locale was not supplied as a route parameter');
      }

      const isSupportedLocale = supportedLocales.includes(locale.toLowerCase());

      if (!isSupportedLocale) {
        throw new Error('Locale is not supported');
      }

      const formattedLocale = locale.replace(
        /-([a-z]{2})/i,
        (match, group) => `-${group.toUpperCase()}`
      );

      await dispatch(updateLocale(formattedLocale));
    } catch (error) {
      dispatch(applicationError(
        '500',
        error instanceof Error ? error : new Error(error),
        {
          moduleID: MODULE_NAME,
        }
      ));

      if (location.pathname.indexOf('/error') === -1) {
        replace(`${location.pathname}/error/404`);
      }
    }

    return callback();
  };
}
